export const en = {
  appName: "Rikskurs",
  tagline: "Sveriges Riksbank's interest rates and exchange rates, explored",
  "nav.language": "Language",
  "nav.theme": "Toggle theme",
  "category.currency": "Currency",
  "category.interest": "Interest rate",
  "category.index": "Index",
  "picker.series": "Select series",
  "picker.from": "From",
  "picker.to": "To",
  "picker.apply": "Show",
  "chart.value": "Value",
  "chart.date": "Date",
  "table.date": "Date",
  "table.value": "Value",
  "table.change": "Change",
  "unit.sekPerUnit": "SEK per {currency}",
  "unit.percent": "Percent",
  "unit.indexPoints": "Index points",
  "state.loading": "Loading data…",
  "state.empty": "No data available yet for this period. Riksbank typically publishes new figures on the next banking day.",
  "state.error": "Couldn't reach Riksbank's data service. Please try again in a moment.",
  "state.retry": "Try again",
  "footer.source": "Data from Sveriges Riksbank's API",
  "series.repoRate": "Repo rate",
  "series.depositRate": "Deposit rate",
  "series.lendingRate": "Lending rate",
  "series.fineTuningRate": "Fine-tuning rate",
  "series.referenceRate": "Reference rate",
  "series.stiborTN": "STIBOR Tomorrow/Next",
  "series.kixIndex": "KIX (krona index)",
  "series.tcwIndex": "TCW index",
  "readout.latest": "Latest value",
  "readout.asOf": "As of {date}",
  "readout.noData": "No value for this period",
  "table.noChange": "No prior point",
  "table.empty": "No rows to display.",
  "errorBoundary.title": "Something went wrong",
  "errorBoundary.message": "An unexpected error occurred. Please reload the page.",
  "errorBoundary.reload": "Reload",
} as const;

export type TranslationKey = keyof typeof en;
